import { Button, CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

function useTeachers() {
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/teachers')
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        let teachers = data?.data?.map((teacher) => {
          return {
            _id: teacher?._id,
            name: teacher?.name,
            lastName: teacher?.lastName,
            institution: teacher?.institution?.name,
          };
        });
        setTeachers(teachers);
      })
      .catch((err) => {});
  }, []);

  return { teachers, setTeachers, isLoading };
}

export function Teachers(props) {
  const { teachers, setTeachers, isLoading } = useTeachers();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/teachers-update/${id}`);
  };

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
      },
    },
    {
      name: 'lastName',
      label: 'Apellido',
      options: {
        filter: false,
      },
    },
    {
      name: 'institution',
      label: 'Institución',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(teachers[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = async (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los profesores seleccionados?'
    );
    if (confirm) {
      rowsDeleted?.data?.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/teachers/${
            teachers[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        let data = await response.json();
      });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        docentes creados en la plataforma, puedes usar las herramientas,
        filtrar, buscar, imprimir, descargar, para gestionar este módulo.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Profesores'}
          data={teachers}
          columns={columns}
          options={{
            filterType: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
